import { Component, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Referee, ReferenceTypes, RefereeStatus, ReferenceTimeKnownStrings, MonthStrings } from '../../referencing.models';

@Component({
    selector: 'referee-completed',
    templateUrl: './referee-completed.component.html',
    styleUrls: ['./referee-completed.component.scss'],
    standalone: false
})
export class RefereeCompletedComponent implements OnChanges {

  @Input() referee: Referee | null = null;
  @Input() index: number = 0;

  @Output() editDetails:EventEmitter<Referee | null> = new EventEmitter<Referee | null>();

  public ReferenceTypes = ReferenceTypes;
  public referenceTypes = Object.values(ReferenceTypes);
  public referenceType = 0;
  public referenceTimePeriodsObject = Object.values(ReferenceTimeKnownStrings);
  public referenceTimePeriods = this.referenceTimePeriodsObject[0];
  public timeKnown = 0;

  public monthStringObject = Object.values(MonthStrings);
  public months = this.monthStringObject[0];
  public status = 0;
  public borderColours = [
    '#DC1846',
    '#D78A09',
    '#6A3772',
    '#173EAD',
    '#11A5A5',
    '#C0399F',
    '#0EA271',
    '#3A4777',
    '#696E7A'
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes['referee']){
      if(this.referee?.timeKnown){
        this.timeKnown = this.referee.timeKnown;
      }
      if(this.referee?.referenceType){
        this.referenceType = this.referee.referenceType;
      }
      if(this.referee?.status){
        this.status = this.referee.status;
      }
    }
  }

  public getEndDateString():string {
    if (this.referee!.currentRole) {
      return 'Current role'
    }
    if (this.referee!.endDateMonth){
      return `${this.months[this.referee!.endDateMonth]} ${this.referee!.endDateYear}`;
    }
    return '';
  }

  public onEditDetails(): void {
    this.editDetails.emit(this.referee);
  }

  public get RefereeStatus() {
    return RefereeStatus;
  }

  public truncate(str: string, length: number): string {
    return str.length > length ?
      str.substring(0, length) + '...' :
      str;
  }
}
